/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import { bool, shape, string } from 'prop-types';
import mbpLogger from 'mbp-logger';

import Divider from '../../common/Divider';
import { useAuth } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';
import * as api from '../../../../../apis/account-apis/fetchEmailAddressFromId';
import { getIsAuthenticatedStatus } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import Helper from '../../state/reducers/Helper';
import GiftListRecommendationsSFContainer from './GiftListRecommendationsSFContainer';

const GiftListLandingPage = ({
    cStatus,
    indivId,
    custNbr,
    featureFlags,
}) => {
    const [emailId, setEmailId] = useState();
    const {
        loginByRedirect,
        getAccessTokenSafely,
    } = useAuth();

    const isAuthenticated = useSelector(getIsAuthenticatedStatus);

    useEffect(() => {
        Helper.setSessionStorageObject('common', { custNbr }, false);

        async function getEmailIdFromIndivId() {
            try {
                if (!isAuthenticated) {
                    const accessToken = await getAccessTokenSafely();
                    const response = await api.fetchEmailAddressFromId({}, accessToken, indivId);

                    if (response?.data?.email) {
                        setEmailId(response?.data?.email);
                    }
                }
            } catch (ex) {
                mbpLogger.logError({
                    module: 'mbp-pwa-ui',
                    fileName: 'GiftListLandingPage.js',
                    function: 'getEmailIdFromIndivId',
                    jsError: ex,
                    message: 'failed to get emailId using indivId',
                });
            }
        }

        getEmailIdFromIndivId();
    }, [custNbr, indivId, isAuthenticated]);

    const handlePasswordLessLogin = async () => {
        Helper.setSessionStorageObject('common', { custNbr }, false);
        Helper.setSessionStorageObject('common', { isCodeSentToEmail: true });
        await loginByRedirect({
            redirect_uri: `${window.location.origin}/auth/callback`,
            login_hint: emailId,
            connection: 'email',
            userEmailId: emailId,
            isPasswordLessLogin: 'Y',
            custNbr,
        }, {
            routeBack: '/account/gift-list',
        });
    };

    if (typeof window !== 'undefined' && isAuthenticated) {
        window.location.href = '/account/gift-list';
    }

    return (
        <>
            <div className="margin-top-2x padding-bottom-2x align-center">
                <h1>Welcome Gift List customer</h1>
            </div>

            {
                featureFlags['is-giftlist-pin-number-enabled']
                && emailId
                && (
                    <>
                        <div className="align-center">
                            <p>Forgot Password? Click this button and we&apos;ll email you a PIN number to access your Gift List</p>
                        </div>
                        <div className="align-center">
                            <Button
                                className="buttonHDSecondaryRound sign-in-btn"
                                onClick={handlePasswordLessLogin}
                            >
                                Get Pin Number
                            </Button>
                        </div>
                        <Divider text="or" />
                    </>
                )
            }

            {(/^E/.test(cStatus)) ? (
                <div className="align-center row">
                    <Button
                        className="buttonHDSecondaryRound sign-in-btn"
                        onClick={async () => {
                            await loginByRedirect();
                        }}
                    >
                        Sign In
                    </Button>
                </div>

            ) : ''}

            <div className="align-center row">
                <Button
                    className="buttonHDSecondaryRound sign-in-btn"
                    onClick={async () => {
                        await loginByRedirect({}, { register: 'Y' });
                    }}
                >
                    Create Account
                </Button>
            </div>
            <GiftListRecommendationsSFContainer title_font_size="26px" title_font_style="normal" title_font_family="'LatoRegular', 'Arial', 'Verdana', sans-serif" />
        </>
    );
};

GiftListLandingPage.propTypes = {
    cStatus: string.isRequired,
    indivId: string.isRequired,
    custNbr: string.isRequired,
    featureFlags: shape({
        'is-giftlist-pin-number-enabled': bool,
    }).isRequired,
};

export default GiftListLandingPage;
